import { css } from 'styled-components';

const variables = css`
  :root {
    // --dark-navy: #2a363d;
    // --navy: #0a192f;
    // --light-navy: #112240;
    // --lightest-navy: #233554;
    // --navy-shadow: rgba(2, 12, 27, 0.7);
    // --dark-slate: #495670;
    // --slate: #8892b0;
    // --light-slate: #a8b2d1;
    // --lightest-slate: #ccd6f6;
    // --white: #e6f1ff;
    // --green: #64ffda;
    // --green-tint: rgba(100, 255, 218, 0.1);
    // --pink: #f57dff;
    // --blue: #57cbff;

    // loading screen background
    --dark-navy: #805e80; // #9c948f;//#2E3E58;//#0a141a;

    // main background colour
    --navy: #694b69; //#895488; //#ccbacc; //#C4BBB6; //#c7b1ab; // #DFE0DA;                // #2E3141; // 12242e; // bg - border & div squares

    // background for all div boxes, work, ft projects etc
    --light-navy: #9e7d9e; //#b3a9a4;//#9C948F;//#353849; // #2a5066; // div boxes

    // lines between sections and for work exp
    --lightest-navy: #9c948f; //#4f99c4;       // section lines

    // shadow for navbar, pics and divs
    --navy-shadow: #805e80; //#bd705e;//#9D5F97;// #FCB424; // #2d566e; // shadow of boxes and borders

    // scroll bar
    --dark-slate: #805e80; //#9c948f;//#2E3E58;//#3b789c;  // scroll bar

    // text: 1. para under get in touch
    // 2. place and tech in projects
    // 3. text for main para of work exp
    // 4. main about me text
    // 5. bio under name big and smol both
    --slate: #ccc4c0; //#b8b0ab;// #9c948f;//#97a2a6; //#93a4ad;  // all whitish texxt

    // logos, line and email etc at the side bars
    // time period of work exp
    // main text of p=ft projects + tech
    // main text of projects
    // main text of honors
    // footer credit statement
    --light-slate: #e8cfe8; // #c49dc4;//#8a817c;//#73583A;//#a0d9fa; // other text and gmail, ln, github etc

    // text in navbar
    // rafsha mazhar
    // section headers - about me, where i have worked etc
    // job title in where ive worked
    // proj title in ft projects  + link logo like github
    // title of projects & awards
    --lightest-slate: #e3dfdc; // #D7D4D2;//#bab5b1;//#7C7672;//#D7D4D2;//#d6c6bc;//#9c948f;//#dceffa; // headings + name

    // nowhere???
    --white: #e6f1ff;

    // R logo + numbering in navbar
    // Hi, I am statement before rafsha mazhar
    // resume, connect etc button outline and text
    // links
    // frame for picture
    // toggle text for pictures
    // bullets icon
    // work exp selected place name
    // ft project img highlight
    // places text for projects awards etc
    --green: #c49dc4; //#78716d;//#8c8581;//#D7D4D2;//#31201A;//#509ecc;  // all green stuff

    // button fill on hover
    --green-tint: #9e7d9e; //#b5ada7;//#C3BEBB;//rgba(100, 255, 218, 0.1);

    // nowhere???
    --pink: #f57dff;

    // nowehere??
    --blue: #57cbff;

    --font-sans: 'Calibre', 'Inter', 'San Francisco', 'SF Pro Text', -apple-system, system-ui,
      sans-serif;
    --font-mono: 'SF Mono', 'Fira Code', 'Fira Mono', 'Roboto Mono', monospace;

    --fz-xxs: 12px;
    --fz-xs: 13px;
    --fz-sm: 14px;
    --fz-md: 16px;
    --fz-lg: 18px;
    --fz-xl: 20px;
    --fz-xxl: 22px;
    --fz-heading: 32px;

    --border-radius: 4px;
    --nav-height: 100px;
    --nav-scroll-height: 70px;

    --tab-height: 42px;
    --tab-width: 120px;

    --easing: cubic-bezier(0.645, 0.045, 0.355, 1);
    --transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);

    --hamburger-width: 30px;

    --ham-before: top 0.1s ease-in 0.25s, opacity 0.1s ease-in;
    --ham-before-active: top 0.1s ease-out, opacity 0.1s ease-out 0.12s;
    --ham-after: bottom 0.1s ease-in 0.25s, transform 0.22s cubic-bezier(0.55, 0.055, 0.675, 0.19);
    --ham-after-active: bottom 0.1s ease-out,
      transform 0.22s cubic-bezier(0.215, 0.61, 0.355, 1) 0.12s;
  }
`;

export default variables;
